import type { DeliveryGoLiveConflict } from "../../../../merchflow/store/pog/_storePogId_/delivery-conflicts";

/** The conflicts "Mark all as delivered" on this merchflow would create. */
export const RouteGetMerchflows_MerchflowId_StoresPogsDeliveryConflicts =
  "/merchflows/:merchflowId/stores/pogs/delivery-conflicts";

export interface ResponseGetMerchflows_MerchflowId_StoresPogsDeliveryConflicts {
  conflicts: DeliveryGoLiveConflict[];
}
